module.exports = __webpack_public_path__ + "static/media/crop-image.d74f8842.png";